export enum EOrdersType {
  CONCLUDED = 'concluded',
  OPENED = 'opened'
}
